import Cookies from 'js-cookie';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';

const AB_TESTS_COOKIE_PREFIX = 'ab_tests_';

export interface AbTest {
  uuid: string;
  slug: string;
  version: string;
}

export default class AbTests {
  getTests(): string[] {
    const { abTests } = useTravelataAppConfig();

    return Array.isArray(abTests) ? abTests : [];
  }

  hasTest(testName: string): boolean {
    return this.getTests().includes(testName);
  }

  getCookie(): AbTest[] | null {
    const cookie = Cookies.get(this.getCookieName());

    if (!cookie) return null;

    try {
      const value: unknown = JSON.parse(cookie);

      return Array.isArray(value) ? (value as AbTest[]) : null;
    } catch {
      return null;
    }
  }

  private getCookieName(): string {
    const { isMobileDomain } = useTravelataAppConfig();

    return `${AB_TESTS_COOKIE_PREFIX}${isMobileDomain ? 'mobile' : 'desktop'}`;
  }
}

const abTests = new AbTests();

export { abTests };
